import React, { useState, useEffect } from "react";
import { Phone } from "lucide-react";
import { company } from "../mock";

export default function FloatingCall() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href={company.phoneHref}
      aria-label="Call us"
      className={`fixed bottom-6 right-6 z-50 grid place-items-center h-14 w-14 rounded-full bg-gold text-ink shadow-[0_10px_30px_rgba(201,162,74,0.5)] transition-all duration-300 hover:bg-gold-dark hover:scale-105 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <span className="absolute inset-0 rounded-full bg-gold animate-ping opacity-30" />
      <Phone size={22} className="relative" />
    </a>
  );
}
